import { DocumentNode, Kind, OperationTypeNode } from 'graphql';

import { getFragmentDefinitionNode } from './getFragmentDefinitionNode';

/**
 * Créé une query à partir d'un fragment généré par codegen.
 *
 * @param fieldName Nom de la query
 * @param fragment Le fragment
 */
export const generateQueryFromFragment = ({
  fieldName,
  fragment,
}: {
  fieldName: string;
  fragment: DocumentNode;
}): DocumentNode => {
  return {
    kind: Kind.DOCUMENT,
    definitions: [
      {
        directives: [],
        variableDefinitions: [],
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        selectionSet: {
          kind: Kind.SELECTION_SET,
          selections: [
            {
              arguments: [],
              kind: Kind.FIELD,
              name: { kind: Kind.NAME, value: fieldName },
              directives: [
                {
                  arguments: [],
                  kind: Kind.DIRECTIVE,
                  name: { kind: Kind.NAME, value: 'client' },
                },
              ],
              selectionSet: getFragmentDefinitionNode(fragment).selectionSet,
            },
          ],
        },
      },
    ],
  };
};
